import axios, { getData } from 'lib/axios'

export const getAssessmentResult = () => {
  return axios.get(`/recruitment/staff-personality-test/individual`).then(getData)
}

export const submitAssessment = (data) => {
  return axios.post(`/recruitment/staff-personality-test/individual`, data).then(getData)
}

export const retakeAssessment = (data) => {
  return axios.put(`/recruitment/staff-personality-test/individual`, data).then(getData)
}